export { default as PointLogo24x24Icon } from './point_logo_24x24.svg';
